export default {
    missionVision: [
        {
            title: "Vision",
            imgIcon: "vision",
            content:
                "Netcom is to provide ubiquitous, secure and seamless access to information resources in all forms through reliable and robust infrastructure.To build better solution for education industry through AI and machine learning capabilities in many areas of space operations to enable people to empower the knowledge of the application of education.",
        },
        {
            title: "Mission",
            imgIcon: "mission",
            content:
                "To provide best of breed software products to enable organization to run their businesss and operations better.To deliver effective IT solution and quality services.To enchance the competitive advantages of our clients.To maintain a sustainable social environment and be a socially responsible corporate citizen.",
        },
    ],


    features: [
        {
            name: "DashBoard",
            points:[
                "Monitor the  Orders, Profits & Customers of your Entire Shop."
            ]
        },
        {
            name:"Know your Customer",
            points:[
                "Keep a Data of Customer’s Names, Address, Phone Numbers and Measurements for future",
                "Manage your Customers easily with their Measurements",
                "Know your valued Customer and take care of them",
                "Track the Overall Orders of the Customers",
                "Search with Customer Name and Customer Mob. No to get Instant Details"
            ]
        },
        {
            name:"Manage Your Orders",
            points:[   
              "Say Good Bye to Paper Works. Now Store Your Orders in Digital Form",
              "Store the Measurements in digital Format",
              "Track the current status of the order based on the categories like Confirmed, Processing, Ready, due payment paid, and delivered",
              "Download the Orders List as Excel File for Future Use",
              "Search with Order ID, Customer Name and Customer Mob. No to get Instant Details"
            ]
        },
        {
            name:"Placing Orders",
            points:[
                "Place your Orders for Salwar, Blouse, Shirt, Pants and more",
                "No need for Repeated Measurements for Customers. Once Stored, You can use it for other Orders for that Customer",
                "You can also Print the Measurements and Start Stiching",
                "Capture and Store the Dress Image and Stiched Dress Image"
            ]
        },
        {
            name:"Rates Updater",
            points:[
                "Easily modify the Cost of Stiching Charges",
                "Update Costs at anytime"
            ]
        },
        {
            name:"Full Reports of Sales or Orders",
            points:[
                "Get a comprehensive report on the overall sales and orders you have received over the past few months and years",
                "Results can be filtered by days, weeks, and months for convenient tracking"
            ]
        },
        {
            name:"Smart Billing",
            points:[
                "Bills will be Generated automatically for the Order",
                "GST and Discount Options Available"
            ]
        }

    ],
    mobileAppFeatures:[
        {
            name:"App Features",
            points:[
                "App Helps you to track all the Status of your Orders",
                "See Live Stiched Dress Images of your Orders",
                "Dress Shop location Available in App",
                "Know about the Shop Details"
            ]
        }
    ],
    about: " is a responsive and easy to use tailor shop management system that could help you manage your tailor shop business very well with customers, their measurements, orders & payments."

   

}
